import { render, staticRenderFns } from "./ServicesList.vue?vue&type=template&id=57257369&scoped=true"
import script from "./ServicesList.vue?vue&type=script&lang=js"
export * from "./ServicesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57257369",
  null
  
)

export default component.exports